import React from 'react'
import CheckoutForm from '../components/CheckoutForm'

const Checkout = () => {
  return (
    <div>
        <CheckoutForm />
    </div>
  )
}

export default Checkout